export default {"src":"/_next/static/media/medal.e8294f33.svg","height":32,"width":24};